// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const fields = {
  default: [
    // {
    //   key: "id",
    //   label: "编号",
    //   type: "button",
    //   button: { type: "text" },
    //   thStyle: {
    //     width: "80px"
    //   }
    // },
    {
      key: "set_date",
      label: "日期",
      sortable: true,
      type: "date",
      thStyle: {
        width: "120px"
      }
    },
    {
      key: "AccountNum",
      label: "供应商账户",
      sortable: true
    },
    {
      key: "SEI_Name",
      label: "供应商名称",
      sortable: true
    },
    {
      key: "ProductionCapacity",
      label: "剩余产能（天）",
      sortable: true,
      type: "number"
    },

    {
      key: "description",
      label: "备注",
      sortable: true
    },
    {
      key: "create_by",
      label: "创建人",
      formatter: (value, key, item) => {
        return item.create_by_username
      }
    },
    // {
    //   key: "is_deleted",
    //   label: "删除",
    //   type: "boolean"
    // },
    // {
    //   key: "is_approved",
    //   label: "审批",
    //   type: "boolean"
    // }
  ],
  export_field: [{
    key: "AccountNum",
    label: "供应商账户",
    sortable: true
  },
  {
    key: "SEI_Name",
    label: "供应商名称",
    sortable: true
  },
  {
    key: "ProductionCapacity",
    label: "剩余产能",
    sortable: true,
    // type: "number"
  },
  {
    key: "set_date",
    label: "日期",
    sortable: true,
    type: "date"
  },
  {
    key: "description",
    label: "备注",
    sortable: true
  }
  ]
}

const dataForm = {
  id: "",
  AccountNum: "",
  SEI_Name: "",
  ProductionCapacity: "",
  set_date: "",
  description: ""
}

///前端验证
const rules = {
  AccountNum: [{
    required: true,
    message: "请选择供应商",
    trigger: "change"
  }],
  ProductionCapacity: [{
    required: true,
    message: "请输入产能",
    trigger: "blur"
  }
  ],
  set_date: [{
    required: true,
    message: "请选择日期",
    trigger: "change"
  }]
}

const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  "sPlant_ProductionCapacity",
  create,
  descriptor
)
const methods = {
  async SaveProductionCapacityExport(json) {
    const code_biz_data = new biz_data_helper.base_entity_helper(
      "generate_ProductionCapacity", {}, {}
    )
    let result = await code_biz_data
      .execAction({
        params: {
          json: json
        },
        fields: []
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get

  async getData(_params) {
    let _fields = _.map(fields.default, "key")
    _fields.push("is_deleted")
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _fields
      })
      .run()
    //
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///save
  async saveData(items) {
    let _actions = []
    const check_biz_data = new biz_data_helper.base_entity_helper(
      "update_existe_production_capacity", {}, {}
    )
    let _fields = _.map(fields.default, "key")
    _fields.push("id")
    _.each(items, t => {
      let _t = _.cloneDeep(t)
      if (_t.id == "") {
        _actions.push(
          check_biz_data
            .execAction({
              params: {
                AccountNum: _.toString(t.AccountNum),
                set_date: t.set_date
              }
            })
            .action({})
        )
        delete _t.id
        _actions.push(
          biz_data
            .insertAction({
              params: _t,
              fields: _fields
            })
            .action({})
        )
      } else {
        _actions.push(
          biz_data
            .updateAction({
              params: _t,
              fields: _fields
            })
            .action({})
        )
      }
    })
    let result = await api.query_batch({
      actions: _actions
    })

    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  ///delete
  async deleteData(items) {
    let _actions = []
    _.each(items, t => {
      _actions.push(
        biz_data
          .deleteAction({
            params: {
              id: t.id
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },

  ///approved
  async approveData(items) {
    let _actions = []
    _.each(items, t => {
      _actions.push(
        biz_data
          .approveAction({
            params: {
              id: t.id,
              is_approved: t.is_approved
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  }
}
export {
  fields,
  dataForm,
  methods,
  rules,
  biz_data
}
